module.exports = __webpack_public_path__ + "media/images/brand_icons/icon_rumble-27c3624e6abd09daca6aacf5cabfa1c1.svg";